import { ShieldExclamationIcon } from '@heroicons/react/24/outline'
import { Button } from '@nextui-org/react'

export function Unauthorized() {
  return (
    <div className="flex h-[60vh] items-center justify-center" role="alert">
      <div className="text-center">
        <ShieldExclamationIcon
          aria-hidden="true"
          className="mx-auto h-12 w-12 text-danger"
        />
        <h1 className="mt-4 text-2xl font-bold">Unauthorized</h1>
        <p className="mt-2">You are not authorized to access this page</p>
        <Button
          as={`a`}
          className="mt-8 uppercase"
          color="primary"
          href="/"
          variant="solid"
        >
          Back to homepage
        </Button>
      </div>
    </div>
  )
}

export default Unauthorized
